import React from "react";
import { Group, Text, Box } from '@mantine/core';

import { stringDivider, safeValue, getPropInSubLevelRole, sqlDateToHumanDate } from "../../utils/globalFunctions";

const NomorNotaDibatalkan = ({ stateData }) => {

    return (
        <React.Fragment>
            <Text size='sm' fw={500}>{stateData.data.label}</Text>

            <Group position="apart" mt='.35rem'>
                <Text size='sm'>
                    {stringDivider(stateData.data.value.id, [4, 6, 8], '.', '[Nomor Nota]')}
                </Text>
            </Group>

            {stateData.data.value.userCreatedName &&
                <Box mt='.5rem'>
                    <Text size='xs' color="dimmed">
                        {safeValue(stateData.data.value.userCreatedName, '')} {stateData.data.value.userCreatedSubLevel ? `(${getPropInSubLevelRole(stateData.data.value.userCreatedSubLevel, 'caption', '')})` : ''} {stateData.data.value.createdDateTime ? `- ${sqlDateToHumanDate({
                            stateDate: stateData.data.value.createdDateTime,
                            stateWithTime: true,
                            stateLang: 'id',
                            stateIsShort: true,
                            stateDay: false,
                            stateDefaultValue: '',
                            stateDateType: 'day',
                            stateWithSecond: false
                        })}` : ''}
                    </Text>
                </Box>
            }
        </React.Fragment>
    )
}

export default NomorNotaDibatalkan;